import React from 'react';

const NotFound = () => (
	<div className="bg-lightgray section" id="blog-page">
		<h1 className="section-title">404 Page Not Found</h1>
	</div>
)

export default NotFound;